import { Env, readFromEnv } from "@cinch-nx/environments";
import axios from "axios";
import { convertSearchFiltersToQueryParams } from "../../utils";
import { useSearchFilters } from "../use-search-filters";
import { useState } from "react";
export const httpClient = axios.create();
export function useSearchAlerts() {
    const { params  } = useSearchFilters();
    const searchApiUrl = readFromEnv(Env.SearchServiceUrl);
    const queryParams = convertSearchFiltersToQueryParams(params);
    const [fetchStatus, setFetchStatus] = useState("initial");
    const [error, setError] = useState(null);
    const url = `${searchApiUrl}/alert`;
    const registerSearchAlert = async (email, frequency)=>{
        if (!email || !frequency) {
            return;
        }
        setError(null);
        setFetchStatus("pending");
        try {
            await httpClient.post(url, {
                sa_email_address: email,
                sa_frequency: frequency,
                sa_url: `?${queryParams}`
            }, {
                headers: {
                    "x-search-api-consumer": "search-used-cars"
                }
            });
            setFetchStatus("success");
        } catch (error_) {
            setError(error_);
            setFetchStatus("error");
        }
    };
    return {
        registerSearchAlert,
        fetchStatus,
        error
    };
}
